<template>
  <v-snackbar class="mpay-layout__success-message"
    :value="show"
    :color="type"
    :top="true"
    :multi-line="true"
    :auto-height="true"
    :timeout="timeout ? timeout : 6000"
    :vertical="false"
  >
    <span>
      <v-alert class="mx-0 my-0 px-0 py-0" :value="true" :type="type">
        <slot/>
      </v-alert>
    </span>
    <v-btn dark flat @click="closeMessage">
      Close
    </v-btn>
  </v-snackbar>
</template>

<script>
export default {
  name: 'MPayMessage',
  props: ['type', 'value', 'trigger', 'timeout'],
  data: () => ({
    show: false,
  }),
  methods: {
    closeMessage() {
      this.show = false;
    },
    showMessage() {
      this.closeMessage();
      // make message (if any) disappear before displaying it (again)
      this.$nextTick().then(() => { this.show = this.value; });
    },
  },
  watch: {
    value() {
      this.showMessage();
    },
    trigger() {
      this.showMessage();
    },
  },
};
</script>

<style>
  .mpay-layout__success-message .v-alert {
    border: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/MPayMessage.vue